import React, { useEffect, useRef, useState } from 'react';
import { IOT_BASE_URL, ORG_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import HttpAPICall from '../../../services/HttpAPICall';
import { toast } from 'react-toastify';
import TapIcon from '../../../services/TapIcon';
import { Modal } from "bootstrap";
import { Link } from 'react-router-dom';
import uuid from "react-uuid";
import { useSelector } from 'react-redux';
import swal from 'sweetalert';
import TapSelect from '../../../components/ui/TapSelect';
import Loader from '../../../components/ui/Loader/Loader';
import InputAssetSearch from '../../includes/ui/InputAssetSearch';
import InputUserSearch from '../../includes/ui/InputUserSearch';
import { DisplayListPagination } from '../../../components/TapUi/index';

function NotificationConfiguration() {

    const modalId                   =   uuid();
    const modalElementRef           =   useRef();
    const modalRef                  =   useRef();
    const notificationUrl           =   IOT_BASE_URL + '/notification_rules';
    const access_token              =   useSelector(state => state.auth.access_token);
    const user_sites                =   useSelector(state => state.app.user_sites ? state.app.user_sites : []);
    const asset_type                =   useSelector(state => state.app && state.app.asset_type ? state.app.asset_type : []);
    const initialData = {
        notification_preferences    :    [],
        notification_type_support   :    [],
        site_ids                    :    [],
        asset_type_ids              :    [],    
        asset_ids                   :    [],
        user_ids                    :    [],
    };
    const [notificationTypeOptions, setNotificationTypeOptions]     =   useState([]);
    const [currentPage, setCurrentPage]                             =   useState(1);
    const [searchedUsers, setSearchedUsers]                         =   useState([]);
    const [searchedAssets, setSearchedAssets]                       =   useState([]);
    const [formData, setFormData]                                   =   useState({
        submittingForm      :   false,
        editId              :   '',
        submitData          :   initialData
    });
    const [notificationData, setNotificationData]                   =   useState({
        loading             :   false,
        data                :   [],
        notification_types  :   [],
        meta                :   null
    });
    const [notificationFormData, setNotificationFormData]           =   useState({
        loading             :   false,
        formData            :   null
    });


    const formattedSites = user_sites.map(site => ({
        value: site.id,
        label: `${site.site_name} (${site.site_code})`
    }));

    const formattedAssetTypes = asset_type.map(type => ({
        value: type.id,
        label: type.asset_type_name
    }));

    useEffect(() => {
        modalElementRef.current = document.getElementById(modalId);
        modalRef.current = new Modal(modalElementRef.current, { keyboard: false, backdrop: false });
        getNotificationFormdata();
        getNotifications(1);

        return () => {
            if (modalRef.current) {
                modalRef.current.dispose();
            }
        };
    }, []);

    const openModal = () => {
        if (modalRef.current) {
            modalRef.current.show();
        }
    }

    const closeModal = () => {
        if (notificationFormData?.formData?.notification_types) {
            const notificationTypeSupport = notificationFormData.formData.notification_types.map(type => ({
                id: type.id,
                notification_name: type.name,
                sms_supported: type.sms == 1,
                inApp_supported: type.inApp == 1,
                email_supported: type.email == 1,
            }));

            const notificationPreferences = notificationFormData.formData.notification_types.map(type => ({
                id: type.id,
                notification_name: type.name,
                sms: 0,
                inApp: 0,
                email: 0,
            }));

            setFormData(pre => ({
                ...pre,
                editId: '',
                submitData: {
                    notification_type_support: notificationTypeSupport,
                    notification_preferences: notificationPreferences,
                    site_ids: [],
                    asset_type_ids: [],
                    asset_ids: [],
                    user_ids: [],
                }
            }));
        } else {
            setFormData(pre => ({
                ...pre,
                editId: '',
                submitData: initialData
            }));
        }

        setSearchedUsers([]);
        setSearchedAssets([]);

        if (modalRef.current) {
            modalRef.current.hide();
        }
    };

    const handleNotificationCheckbox = (index, field, checked) => {

        setFormData(pre => {

            const updatedNotifications = [...pre.submitData.notification_preferences];

            updatedNotifications[index] = {
                ...updatedNotifications[index],
                [field]: checked ? 1 : 0
            };

            return {
                ...pre,
                submitData: {
                    ...pre.submitData,
                    notification_preferences: updatedNotifications
                }
            };
        });
    };

    const getNotificationFormdata = () => {
        setNotificationFormData(pre => ({ ...pre, loading: true }));
        HttpAPICall.withAthorization("GET", `${notificationUrl}/form_data`, access_token, {}, {}, (response) => {
            const formDataResponse = response.data;
            setNotificationFormData(pre => ({ ...pre, formData: formDataResponse }));
            if (formDataResponse?.notification_types) {

                const notificationTypeSupport = formDataResponse.notification_types.map(type => ({
                    id: type.id,
                    notification_name: type.name,
                    sms_supported: type.sms == 1,
                    inApp_supported: type.inApp == 1,
                    email_supported: type.email == 1,
                }));

                const notificationPreferences = formDataResponse.notification_types.map(type => ({
                    id: type.id,
                    notification_name: type.name,
                    sms: 0,
                    inApp: 0,
                    email: 0,
                }));

                setFormData(pre => ({
                    ...pre,
                    submitData: {
                        ...pre.submitData,
                        notification_type_support: notificationTypeSupport,
                        notification_preferences: notificationPreferences
                    }
                }));
            }
        }).then(() => setNotificationFormData(pre => ({ ...pre, loading: false })));
    }
    const getNotifications = (page = 1) => {
        setNotificationData(pre => ({ ...pre, loading: true }));
        HttpAPICall.withAthorization("GET", `${notificationUrl}/list`, access_token, { page }, {}, (response) => {
            const notificationList = response.data || [];

            setNotificationData(pre => ({
                ...pre,
                data: response.data?.rules?.data || [],
                notification_types: response.data?.notification_types || [],
                meta: {
                    from            :   response.data?.rules?.from,
                    to              :   response.data?.rules?.to,
                    total           :   response.data?.rules?.total,
                    last_page       :   response.data?.rules?.last_page,
                    per_page        :   response.data?.rules?.per_page,
                    current_page    :   response.data?.rules?.current_page
                }
            }));
            setCurrentPage(page);
        }).then(() => {
            setNotificationData(pre => ({ ...pre, loading: false }));
        });
    }

    const submitForm = (e) => {
        e.preventDefault();
        setFormData(pre => ({ ...pre, submittingForm: true }));
        let method = 'POST';
        let url = `${notificationUrl}/add`;

        const { notification_type_support, ...payloadData } = formData.submitData;

        const filteredNotificationPreferences = payloadData.notification_preferences.filter(
            pref => pref.sms == 1 || pref.inApp == 1 || pref.email == 1
        );

        let params = {
            notification_preferences: filteredNotificationPreferences.map(pref => ({
                id: pref.id, 
                sms: pref.sms,
                inApp: pref.inApp,
                email: pref.email
            })),
            site_ids: payloadData.site_ids,
            asset_type_ids: payloadData.asset_type_ids,
            asset_ids: payloadData.asset_ids,
            user_ids: payloadData.user_ids,
        };

        if (formData.editId) {
            method = "PUT";
            url = `${notificationUrl}/edit`;
            params = { ...params, id: formData.editId }
        }

        console.log("Payload being sent:", params);

        HttpAPICall.withAthorization(method, url, access_token, {}, params, (response) => {
            toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
            closeModal();
            getNotifications(1);
        }).then(() => {
            setFormData(pre => ({ ...pre, submittingForm: false }));
        }).catch((error) => {
            toast.error(error.response?.data?.msg , { position: toast.POSITION.TOP_RIGHT });
            setFormData(pre => ({ ...pre, submittingForm: false }));
        });
    }
    const handleEdit = (id) => {
        const editData = notificationData.data.find(d => d.id == id);
        if (!editData) return;
        const allNotificationTypes = notificationFormData.formData?.notification_types || [];
        const savedPreferences = (editData.notification_preferences || []);
        const notification_preferences = allNotificationTypes.map(notificationType => {
            const savedPreference = savedPreferences.find(
                saved => saved.notification_type == notificationType.id
            );

            return {
                id                  :   notificationType.id,
                notification_name   :   notificationType.name,
                sms                 :   savedPreference?.sms || 0,
                inApp               :   savedPreference?.inApp || 0,
                email               :   savedPreference?.email || 0,
            };
        });

        const notification_type_support = allNotificationTypes.map(notificationType => ({
            id: notificationType.id,
            notification_name: notificationType.name,
            sms_supported: notificationType.sms == 1,
            inApp_supported: notificationType.inApp == 1,
            email_supported: notificationType.email == 1,
        }));

        setFormData(pre => ({
            ...pre,
            editId: id,
            submitData: {
                ...pre.submitData,
                notification_type_support,
                notification_preferences,
                site_ids: editData.sites?.map(site => site.id) || [],
                asset_type_ids: editData.asset_types?.map(at => at.id) || [],
                asset_ids: editData.assets_data?.map(asset => asset.id) || [],
                user_ids: editData.users?.map(user => user.id) || [],
            }
        }));
        
        if (editData.users && editData.users.length > 0) {
            const formattedUsers = editData.users.map(user => ({
                value: user.id,
                label: user.full_name || `${user.first_name} ${user.last_name}`,
                first_name: user.first_name,
                last_name: user.last_name,
                email: user.email,
                mobile: user.mobile
            }));
            setSearchedUsers(formattedUsers);
        } else {
            setSearchedUsers([]);
        }

        if (editData.assets_data && editData.assets_data.length > 0) {
            const formattedAssets = editData.assets_data.map(asset => ({
                value: asset.id,
                label: asset.asset_name || asset.asset_nickname,
                display_label: asset.asset_name || asset.asset_nickname,
                tap_asset_id: asset.tap_asset_id,
                asset_matrix_id: asset.asset_matrix_id,
                asset_name: asset.asset_name,
                asset_nickname: asset.asset_nickname
            }));
            setSearchedAssets(formattedAssets);
        } else {
            setSearchedAssets([]);
        }

        openModal();
    }

    const handleDelete = (id) => {
        let notification = notificationData.data.find(c => c.id == id);
        if (notification) {
            swal({
                title: "DELETE",
                text: "This action cannot be reversed, Are you sure you want to proceed?",
                icon: "warning",
                dangerMode: true,
                buttons: ["No", "Yes"],
            }).then(willDelete => {
                if (willDelete) {
                    HttpAPICall.withAthorization('DELETE', `${notificationUrl}/delete/${id}`, access_token, {}, {}, (response) => {
                        toast.success(response.data.msg, { position: toast.POSITION.TOP_RIGHT });
                        getNotifications(currentPage);
                    }).catch(error => {
                        toast.error(error.response?.data?.msg);
                    });
                }
            });
        }
    }

    const modalJsx = () => {
        const { submittingForm, editId, submitData } = formData;

        return <div className="modal fade" id={modalId} ref={modalElementRef} tabIndex="-1">
            <div className="modal-dialog modal-lg ">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">{editId ? "Edit" : "Add"} Notification</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" disabled={submittingForm} onClick={closeModal} aria-label="Close"></button>
                    </div>
                    <div className="modal-body">
                        {notificationFormData.loading ? <Loader /> : (<>
                            <form onSubmit={submitForm} id={modalId + "Form"} method="post">
                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label className="form-label require">Notification Type</label>
                                    </div>
                                </div>
                                <div>
                                    <table className="table table-hover table-bordered my-3 table-sm ">
                                        <thead className="table-secondary">
                                            <tr className='text-center'>
                                                <th scope="col" style={{ width: "5%" }}>#</th>
                                                <th scope="col" style={{ width: "45%" }}>Notification Type</th>
                                                <th scope="col" style={{ width: "15%" }}>SMS</th>
                                                <th scope="col" style={{ width: "15%" }}>In App</th>
                                                <th scope="col" style={{ width: "15%" }}>Email</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {formData.submitData.notification_preferences &&
                                                formData.submitData.notification_preferences.length > 0 ? (

                                                formData.submitData.notification_preferences.map((item, index) => {
                                                    const support = formData.submitData.notification_type_support?.find(s => s.id == item.id);

                                                    return (
                                                        <tr key={item.id}>
                                                            <td className='text-center'>{index + 1}</td>
                                                            <td>{item.notification_name}</td>
                                                            <td className='text-center'>
                                                                {support?.sms_supported ? (
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={item.sms == 1}
                                                                        onChange={(e) =>
                                                                            handleNotificationCheckbox(index, 'sms', e.target.checked)
                                                                        }
                                                                    />
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td>
                                                            <td className='text-center'>
                                                                {support?.inApp_supported ? (
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={item.inApp == 1}
                                                                        onChange={(e) =>
                                                                            handleNotificationCheckbox(index, 'inApp', e.target.checked)
                                                                        }
                                                                    />
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td>
                                                            <td className='text-center'>
                                                                {support?.email_supported ? (
                                                                    <input
                                                                        type="checkbox"
                                                                        className="form-check-input"
                                                                        checked={item.email == 1}
                                                                        onChange={(e) =>
                                                                            handleNotificationCheckbox(index, 'email', e.target.checked)
                                                                        }
                                                                    />
                                                                ) : (
                                                                    "-"
                                                                )}
                                                            </td>
                                                        </tr>
                                                    );
                                                })
                                            ) : (
                                                <tr>
                                                    <td colSpan={5} className="text-center">
                                                        No Notification Types
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label className="form-label">Sites</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <TapSelect
                                            options={formattedSites}
                                            changeEvent={(selectedOption) => {
                                                setFormData(pre => ({
                                                    ...pre,
                                                    submitData: {
                                                        ...pre.submitData,
                                                        site_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : []
                                                    }
                                                }));
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={formattedSites.filter(s => formData.submitData.site_ids.includes(s.value))}
                                            placeholder="Select Sites"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label className="form-label">Asset Types</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <TapSelect
                                            options={formattedAssetTypes}
                                            changeEvent={(selectedOption) => {
                                                setFormData(pre => ({
                                                    ...pre,
                                                    submitData: {
                                                        ...pre.submitData,
                                                        asset_type_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : []
                                                    }
                                                }));
                                            }}
                                            isSearchable={true}
                                            isClearable={true}
                                            isMulti={true}
                                            value={formattedAssetTypes.filter(at => formData.submitData.asset_type_ids.includes(at.value))}
                                            placeholder="Select Asset Types"
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label className="form-label">Assets</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <InputAssetSearch
                                            changeEvent={(selectedOption) => {
                                                setFormData(pre => ({
                                                    ...pre,
                                                    submitData: {
                                                        ...pre.submitData,
                                                        asset_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : []
                                                    }
                                                }));
                                                setSearchedAssets(selectedOption && selectedOption.length > 0 ? selectedOption : []);
                                            }}
                                            isMulti={true}
                                            value={searchedAssets && searchedAssets.length > 0 ? searchedAssets.map(a => { a.label = a.display_label; return a; }) : []}
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                                <div className="row align-items-center my-3">
                                    <div className="col-sm-3">
                                        <label className="form-label">Users</label>
                                    </div>
                                    <div className="col-sm-9">
                                        <InputUserSearch
                                            changeEvent={(selectedOption) => {
                                                setFormData(pre => ({
                                                    ...pre,
                                                    submitData: {
                                                        ...pre.submitData,
                                                        user_ids: selectedOption && selectedOption.length > 0 ? selectedOption.map(o => o.value) : []
                                                    }
                                                }));
                                                setSearchedUsers(selectedOption && selectedOption.length > 0 ? selectedOption : []);
                                            }}
                                            isMulti={true}
                                            value={searchedUsers && searchedUsers.length > 0 ? searchedUsers : []}
                                            containerHeight="30px"
                                            fontSize="93%"
                                        />
                                    </div>
                                </div>

                            </form>
                        </>)}
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" disabled={submittingForm} data-bs-dismiss="modal" onClick={closeModal}>Close</button>
                        <button type="submit" form={modalId + "Form"} disabled={submittingForm} className="btn btn-primary">Save {submittingForm && <TapIcon.FontAwesomeIcon icon={TapIcon.faSyncAlt} className="fa-spin" />}</button>
                    </div>
                </div>
            </div>
        </div>
    }

    return (
        <>
            <div className="tab_content_wrapper my-2">
                <span className="content_heading">GPS Notification</span>
                <button className="btn btn-primary" onClick={openModal}>Add</button>
            </div>
            <table className="table table-bordered my-3 table-sm ">
                <thead className="table-secondary">
                    <tr className='text-center'>
                        <th scope="col" style={{ width: "3%" }}>#</th>
                        <th scope="col" style={{ width: "14%" }}>Notification Type</th>
                        <th scope="col" style={{ width: "6%" }}>SMS</th>
                        <th scope="col" style={{ width: "6%" }}>In App</th>
                        <th scope="col" style={{ width: "6%" }}>Email</th>
                        <th scope="col" style={{ width: "15%" }}>Site Name</th>
                        <th scope="col" style={{ width: "15%" }}>Asset Type</th>
                        <th scope="col" style={{ width: "15%" }}>Assets</th>
                        <th scope="col" style={{ width: "15%" }}>Users</th>
                        <th scope="col" style={{ width: "5%" }}>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {/* {
                        notificationData.loading
                            ?   <tr className='text-center'><td colSpan={10}><Loader /></td></tr>
                            :   notificationData.data.length > 0
                                    ? notificationData.data.map((rule) => {
                                    return (
                                        <tr className='text-center' key={rule.id}>
                                            <td className='text-start'>
                                                <ul className="mb-0 ps-4">
                                                    {rule.notification_preferences?.map((np, index) => {
                                                        const matchedNotification =
                                                            notificationData.notification_types.find(
                                                                nt => nt.id == np.notification_type
                                                            );
                                                        return (
                                                            <li key={index}>
                                                                {matchedNotification?.name || '-'}
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column align-items-center gap-1">
                                                    {rule.notification_preferences?.map((np, index) => (
                                                        <input
                                                            key={index}
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={np.sms == 1}
                                                            disabled
                                                        />
                                                    ))}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column align-items-center gap-1">
                                                    {rule.notification_preferences?.map((np, index) => (
                                                        <input
                                                            key={index}
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={np.inApp == 1}
                                                            disabled
                                                        />
                                                    ))}
                                                </div>
                                            </td>
                                            <td>
                                                <div className="d-flex flex-column align-items-center gap-1">
                                                    {rule.notification_preferences?.map((np, index) => (
                                                        <input
                                                            key={index}
                                                            type="checkbox"
                                                            className="form-check-input"
                                                            checked={np.email == 1}
                                                            disabled
                                                        />
                                                    ))}
                                                </div>
                                            </td>
                                            <td>
                                                {
                                                    rule.sites?.length > 0
                                                        ? rule.sites.map(site => site.site_name).join(', ')
                                                        : '-'
                                                }
                                            </td>
                                            <td>
                                                {
                                                    rule.asset_types?.length > 0
                                                        ? rule.asset_types.map(type => type.asset_type_name).join(', ')
                                                        : '-'
                                                }
                                            </td>
                                            <td>
                                                {
                                                    rule.assets_data?.length > 0
                                                        ? rule.assets_data.map(asset =>
                                                            asset.asset_name || asset.asset_nickname
                                                        ).join(', ')
                                                        : '-'
                                                }
                                            </td>
                                            <td>
                                                {
                                                    rule.users?.length > 0
                                                        ? rule.users.map(user =>
                                                            user.full_name ||
                                                            `${user.first_name} ${user.last_name}`
                                                        ).join(', ')
                                                        : '-'
                                                }
                                            </td>
                                            <td className='text-center'>
                                                <button
                                                    type="button"
                                                    className="btn btn-link"
                                                    data-bs-toggle="dropdown"
                                                >
                                                    <TapIcon.imageIcon
                                                        icon={TapIcon.ListActionIcon}
                                                        className="img-fluid"
                                                        alt="action-icon"
                                                    />
                                                </button>

                                                <ul className="dropdown-menu">
                                                    <li>
                                                        <Link
                                                            role="button"
                                                            className='dropdown-item cursor_pointer'
                                                            onClick={() => handleEdit(rule.id)}
                                                        >
                                                            Edit
                                                        </Link>
                                                    </li>

                                                    <li>
                                                        <Link
                                                            role="button"
                                                            className='dropdown-item cursor_pointer'
                                                            onClick={() => handleDelete(rule.id)}
                                                        >
                                                            Delete
                                                        </Link>
                                                    </li>
                                                </ul>
                                            </td>
                                        </tr>
                                    );
                                })
                                : <tr className='text-center'><td colSpan={10}>No Records</td></tr>
                    } */}


                    {notificationData.loading 
                        ? <tr className='text-center'><td colSpan={10}><Loader /></td></tr> 
                        : notificationData.data.length > 0 ? notificationData.data.map((rule, nindex) => {
                            return (rule.notification_preferences?.map((np, index) => {
                                let notification_type = notificationData.notification_types.find(nt => nt.id == np.notification_type);
                                return  <tr className={["text-center", nindex % 2 === 0 ? "" : "table-light"].join(" ")} key={index+nindex}>
                                    {index === 0 && <td className='text-center' rowSpan={rule.notification_preferences.length}> {nindex + 1} </td>}
                                    <td>{notification_type ? notification_type.name : '-'}</td>
                                    <td className='text-center'>
                                        <input
                                            key={index}
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={np.sms == 1}
                                            disabled
                                        />
                                    </td>
                                    <td className='text-center'>
                                        <input
                                            key={index}
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={np.inApp == 1}
                                            disabled
                                        />
                                    </td>
                                    <td className='text-center'>
                                        <input
                                            key={index}
                                            type="checkbox"
                                            className="form-check-input"
                                            checked={np.email == 1}
                                            disabled
                                        />
                                    </td>
                                    {index === 0 && <td rowSpan={rule.notification_preferences.length}>{rule.sites?.length > 0 ? rule.sites.map(site => site.site_name).join(', ') : '-' }</td>}
                                    {index === 0 && <td rowSpan={rule.notification_preferences.length}>{rule.asset_types?.length > 0 ? rule.asset_types.map(type => type.asset_type_name).join(', ') : '-' }</td>}
                                    {index === 0 && <td rowSpan={rule.notification_preferences.length}>{rule.assets_data?.length > 0 ? rule.assets_data.map(asset => asset.asset_name || asset.asset_nickname ).join(', ') : '-' }</td>}
                                    {index === 0 && <td rowSpan={rule.notification_preferences.length}>{rule.users?.length > 0 ? rule.users.map(user => user.full_name || `${user.first_name} ${user.last_name}`).join(', ') : '-'}</td>}
                                    {index === 0 && <td className='text-center' rowSpan={rule.notification_preferences.length}>
                                        <button type="button" className="btn btn-link" data-bs-toggle="dropdown">
                                            <TapIcon.imageIcon icon={TapIcon.ListActionIcon} className="img-fluid" alt="action-icon" />
                                        </button>
                                        <ul className="dropdown-menu">
                                            <li> <Link role="button" className='dropdown-item cursor_pointer' onClick={() => handleEdit(rule.id)} > Edit </Link></li>
                                            <li> <Link role="button" className='dropdown-item cursor_pointer' onClick={() => handleDelete(rule.id)} > Delete </Link></li>
                                        </ul>
                                    </td>}
                                </tr>
                            }));
                        }) : <tr className='text-center'><td colSpan={10}>No Records</td></tr>
                    }




                </tbody>
            </table>
            <DisplayListPagination
                meta={notificationData.meta}
                onPageChange={(e) => getNotifications(e.selected + 1)}
            />
            {modalJsx()}
        </>
    )
}

export default NotificationConfiguration;